import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:38</span> Introduction of Guest</li>
                            <li><span>01:05</span> Background of our guest.</li>
                            <li><span>08:14</span> The technological shift in the age of the internet</li>
                            <li><span>09:00</span> Gene’s “4 Ps” model for entrepreneurs</li>
                            <li><span>09:40</span> Benefits of going digital for businesses</li>
                            <li><span>11:30</span> Digital Trends and Early barriers 27 years ago</li>
                            <li><span>15:00</span> Mobile app development on a state level</li>
                            <li><span>17:36</span> Challenges of social entrepreneurship</li>
                            <li><span>19:48</span> How to embark on the journey of social entrepreneurship</li>
                            <li><span>24:24</span> The story of Medicine With A Mission</li>
                            <li><span>26:25</span> Facemasks for Maryland – coping with COVID</li>
                            <li><span>30:32</span> How can Businesses survive the Covid-19 pandemic through innovation?</li>
                            <li><span>39:08</span> Triple win methodology</li>
                            <li><span>41:07</span> The future of tech and business – Voice First</li>
                            <li><span>45:28</span> How Did Ryan Get into the tech business <strong>- Audience Question</strong></li>
                            <li><span>47:15</span> How can entrepreneurs #makeAdifference during the Covid-19 pandemic?<strong>Audience Question</strong></li>
                            <li><span>49:15</span> The impact of voice-first on different industries.<strong>– Audience Question</strong></li>
                            <li><span>53:00</span> The need for businesses to embrace modern technology</li>
                            <li><span>56:13</span> How can businesses go digital as a response to the pandemic</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;